import angular from "angular";
import template from "./changelog-entry.html";
import ChangelogEntryController from "./changelog-entry.controller";
import ChangelogEntryDirective from "./ChangelogEntry.directive";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.changelogentry", {
    url: "/changelog/:entry_id",
    controller: ChangelogEntryController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.changelog.entry", [ChangelogEntryDirective.name])
  .config(config)
  .controller("ChangelogEntryController", ChangelogEntryController);
